"use strict";
var $ = require("jquery");
var _ = require("lodash");
var ajaxUtils_1 = require("../../app/utils/ajaxUtils");
var AuthorRewardUtils = (function () {
    function AuthorRewardUtils() {
    }
    AuthorRewardUtils.toggle = function (btn) {
        var $icon = $(btn), $btn = $icon.parent();
        if ($btn.attr("disabled"))
            return;
        $btn.attr("disabled", "disabled").addClass("is-loading");
        var $reward = $($btn.parents(".reward").get(0));
        var rewardId = $reward.attr("data-reward-id"), isHidden = $reward.attr("data-hidden") === "true";
        isHidden = !isHidden;
        ajaxUtils_1.AjaxUtils.post("authorReward/toggleTitleVisibility", {
            id: rewardId,
            isHidden: isHidden
        }).done(function (result) {
            if (result.isSuccessful) {
                $reward.attr("data-hidden", isHidden + "");
                var $rewardTitle = $reward.find(".reward-title");
                if (isHidden) {
                    $rewardTitle.removeClass("text-bold").addClass("text-muted").text("Название скрыто");
                    $btn.html("<button class=\"btn button btn-default btn-sm btn-only-icon\" onclick=\"AppUtils.AuthorReward.toggle(this);\">\
                                                    <span></span>\
                                                    <i class=\"icon-eye\"></i>\
                                                </button>");
                }
                else {
                    $rewardTitle.addClass("text-bold").removeClass("text-muted").text("\u00AB" + result.data.title + "\u00BB");
                    $btn.html("<button class=\"btn button btn-simple-danger btn-sm btn-only-icon\" onclick=\"AppUtils.AuthorReward.toggle(this);\">\
                                                    <span></span>\
                                                    <i class=\"icon-eye-slash\"></i>\
                                                </button>");
                }
                app.f7.addNotification({ message: result.messages[0], button: { text: "ОК", close: true }, hold: 3000 });
            }
            else {
                alert(result.messages[0]);
            }
        }).always(function () {
            $btn.removeAttr("disabled").removeClass("is-loading");
        });
    };
    return AuthorRewardUtils;
}());
_.extend(window["AppUtils"], {
    AuthorReward: AuthorRewardUtils
});
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = AuthorRewardUtils;
//# sourceMappingURL=authorRewardUtils.js.map